import { useActiveDescendantContext } from "./activeDescendantContext";
import { useKeyboardFocusableElement } from "./useKeyboardFocusableElement";
/**
 * @remarks \@since 5.0.0
 */
export function useActiveDescendant(_a) {
    var id = _a.id, ref = _a.ref;
    var activeId = useActiveDescendantContext().activeId;
    var refCallback = useKeyboardFocusableElement(ref);
    return {
        ref: refCallback,
        active: id === activeId,
    };
}
//# sourceMappingURL=useActiveDescendant.js.map